class XYZColor {
  constructor(x, y, z, alpha = 1) {
    this.x = x;
    this.y = y;
    this.z = z;
    this.alpha = alpha;
  }
}

export default XYZColor;
